import { render, staticRenderFns } from "./SnK.vue?vue&type=template&id=d24b016a&"
import script from "./SnK.vue?vue&type=script&lang=js&"
export * from "./SnK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports